import dayjs from "dayjs";

/**
 * Period relative to the current calendar month.
 * @param {"3months"|"5months"|"12months"} preset
 * @returns {[dayjs.Dayjs, dayjs.Dayjs]}
 */
export const DEFAULT_DISPLAYED_PERIOD_PRESET = "12months";

export const DISPLAYED_PERIOD_PRESETS = ["3months", "5months", "12months"];

export const normalizeDisplayedPeriodPreset = (preset) => {
  if (DISPLAYED_PERIOD_PRESETS.includes(preset)) {
    return preset;
  }
  return DEFAULT_DISPLAYED_PERIOD_PRESET;
};

export const getPeriodPresetFromCurrentMonth = (preset) => {
  const current = dayjs().startOf("month");
  const resolvedPreset = normalizeDisplayedPeriodPreset(preset);

  if (resolvedPreset === "3months") {
    return [current.subtract(1, "month"), current.add(1, "month")];
  }

  if (resolvedPreset === "5months") {
    return [current.subtract(2, "month"), current.add(2, "month")];
  }

  // 12 months starting at m-1 (initial affichage)
  const start = current.subtract(1, "month");
  return [start, start.add(11, "month")];
};

/**
 * Fiscal year bounds ending at the given close month (YYYY-MM).
 * e.g. 2027-12 → jan 2027 … déc 2027
 */
export const getExerciceBounds = (fiscalYearEnd) => {
  // Accept both "YYYY-MM" and full date strings from the API
  const end = dayjs(fiscalYearEnd).startOf("month");
  const start = end.subtract(11, "month");
  return { start, end };
};

/**
 * Multi-year period around the current fiscal year.
 * yearsBefore / yearsAfter shift by full fiscal years.
 * e.g. déc 27, before=1 after=1 → jan 26 … déc 28
 */
export const getMultiExercicePeriod = (
  fiscalYearEnd,
  yearsBefore,
  yearsAfter
) => {
  const { start, end } = getExerciceBounds(fiscalYearEnd);
  return [start.subtract(yearsBefore, "year"), end.add(yearsAfter, "year")];
};

export const formatFiscalYearEndLabel = (fiscalYearEnd) => {
  if (!fiscalYearEnd) return "à définir";
  const date = dayjs(fiscalYearEnd, "YYYY-MM");
  if (!date.isValid()) return "à définir";
  const months = [
    "Jan",
    "Fév",
    "Mar",
    "Avr",
    "Mai",
    "Jui",
    "Juil",
    "Aoû",
    "Sep",
    "Oct",
    "Nov",
    "Déc",
  ];
  return `${months[date.month()]}.${String(date.year()).slice(-2)}`;
};
